import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { Picker } from "@react-native-picker/picker";
import { Dimensions } from "react-native";
import { Dropdown } from "react-native-element-dropdown";
import { globalFontStyle } from "../../assets/Font/FontFamily";
import { home_sort } from "../../utils/images";
import Colors from "../../assets/Color/Colors";
import FastImage from "../../common/FastImage";
import { globalImport } from "../../common/globalImports";
import RadioButton from "../RadioButton";
import Width from "../../assets/Width";
import { Color } from "../../assets";

const DropDownProfile = (props) => {
  const {
    selectedData,
    pickerlist,
    onValueChange,
    isLeftIcon = true,
    addMoney = false
  } = props;

  var selected = false;

  return (
    <View>
      <Dropdown
        style={[
          styles.dropdown,

        ]}
        mode={"default"}
        containerStyle={[
          styles.dropdownContainer,
          isLeftIcon ? null : { width: 250 },
          addMoney ? { width: 250 } : null,
          {
            left:
                Width.width > 900
                    ? Width.width < 1200
                        ? Width.width - 250
                        : Width.width - ((Width.width - 1200) / 2 + 200)
                    : Width.width / 2 - 100,
          },
        ]}
        placeholderStyle={styles.placeholderStyle}
        selectedTextStyle={[
          globalFontStyle.appFontSubHeading,
          styles.selectedTextStyle,
        ]}
        activeColor={Colors.bgWhite}
        inputSearchStyle={styles.inputSearchStyle}
        iconStyle={styles.iconStyle}
        data={pickerlist}
        renderItem={(item, selected) => {
          return (
            <View style={[styles.radioOuterBox]} activeOpacity={0.8} key={item}>
              <Text style={{ marginLeft: 15 }}>{item}</Text>
            </View>
          );
        }}
        //maxHeight={300}
        valueField="value"
        value={selectedData}
        placeholder=""
        onChange={(item) => {
          onValueChange(item);
        }}
        onFocus={() => {
          // selected = true;
        }}
        renderLeftIcon={() =>
          isLeftIcon && (
            <Text
              style={[
                selected ? { color: Color.blue1 } : { color: Color.grey7 },
                globalFontStyle.appFontSubHeading,
              ]}
            >
              Profile
            </Text>
          )
        }
        renderRightIcon={isLeftIcon ? () => isLeftIcon && <View /> : false}
      />
    </View>
  );
};
const styles = StyleSheet.create({
  container: {
    backgroundColor: "white",
    padding: 16,
  },
  addMoney: {
    width: Dimensions.get("window").width - 34,
  },
  dropdown: {
    height: "auto",
    borderRadius: 100,

    //paddingHorizontal: 15,
    paddingVertical: 11,
  },
  dropdownContainer: {
    backgroundColor: Colors.bgWhite,
    borderRadius: 8,
    alignSelf: "end",
    //top: -10,
    width: 180,
    //right: 40,
    left: Width.width - 250,
    top: 55,
    position: "absolute",
    //justifyContent: "flex-start",
    //left:Width.width - 150,
    paddingHorizontal: 8,
  },
  radioOuterBox: {
    flexDirection: "row",
    paddingHorizontal: 10,
    paddingVertical: 15,
    //borderRadius: 12,
    alignItems: "center",
    borderColor: Colors.borderColor,
    borderBottomWidth: 0.75,
  },
  sortFilter: {
    backgroundColor: Colors.bgWhite,
    borderRadius: 100,
    //width: 50,
    marginRight: 10,
  },
  icon: {
    marginRight: 5,
  },
  label: {
    position: "absolute",
    backgroundColor: "white",
    left: 22,
    top: 8,
    zIndex: 999,
    paddingHorizontal: 8,
    fontSize: 14,
  },
  placeholderStyle: {
    fontSize: 16,
  },
  selectedTextStyle: {
    color: Colors.grey2,
  },
  iconStyle: {
    width: 20,
    height: 20,
  },
  inputSearchStyle: {
    height: 40,
    fontSize: 16,
  },
});
export default DropDownProfile;
